import React, { memo, ReactNode, useMemo } from 'react'
import { formatDate } from '../../../hooks/useFormatDate'
import TimelineItemHeaderText from '../activity-timeline-item-header-text/activity-timeline-item-header-text'

interface TimelineItemHeaderProps {
  className?: string
  title?: ReactNode
  date?: string
}

const TimelineItemHeader: React.FC<TimelineItemHeaderProps> = memo(
  (props: TimelineItemHeaderProps) => {
    const { className, title, date } = props
    const formattedDate = useMemo<string>(() => formatDate(date), [date])

    return <TimelineItemHeaderText className={className} title={title} text={formattedDate} />
  },
)

TimelineItemHeader.displayName = 'TimelineItemHeader'
export default TimelineItemHeader
